import videosData from '../data/videos.json';
import { isMapped } from './video';
import type { Video } from '../types/video';

export const allVideos = (videosData as Video[])
  .slice()
  .sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime());

export const longForm = allVideos.filter((v) => v.type === 'video');
export const shorts = allVideos.filter((v) => v.type === 'short');
export const topVideos = [...longForm].sort((a, b) => b.views - a.views);
export const mappedVideos = longForm.filter(isMapped);
